// Mock data for Le Phare Administratif et Gestion

export const translations = {
  fr: {
    nav: {
      services: "Services",
      process: "Processus",
      testimonials: "Témoignages",
      faq: "FAQ",
      contact: "Contact"
    },
    hero: {
      tagline: "Votre Guide Stratégique en Administration et Gestion",
      subtitle: "Services professionnels pour entreprises et particuliers - Crédit d'impôt 50% pour les particuliers",
      cta1: "Réserver une Consultation",
      cta2: "Nous Contacter"
    },
    taxCredit: {
      badge: "50% Crédit d'Impôt",
      title: "Bénéficiez de 50% de Crédit d'Impôt",
      subtitle: "Services aux Particuliers",
      description: "En tant que particulier, profitez d'un crédit d'impôt de 50% sur tous nos services d'assistance administrative à domicile. Un avantage fiscal significatif pour alléger vos démarches administratives.",
      example: "Exemple : 100€ de service = 50€ après crédit d'impôt",
      cta: "En Savoir Plus"
    },
    serviceToggle: {
      professional: "Je suis un Professionnel",
      individual: "Je suis un Particulier"
    },
    services: {
      title: "Nos Services",
      subtitle: "Des solutions sur mesure pour vos besoins administratifs et de gestion",
      b2b: [
        {
          title: "Conseil en Gestion d'Entreprise",
          description: "Supervision financière approfondie, audit interne et contrôle de gestion pour optimiser vos performances. Analyse de vos états financiers, tableau de bord de pilotage, ratios de rentabilité et recommandations stratégiques pour maximiser votre croissance.",
          icon: "briefcase"
        },
        {
          title: "Facturation Électronique",
          description: "Explication complète et déploiement de la facturation électronique conforme. Formation pratique sur le traitement et la gestion des e-factures. Accompagnement dans la transition digitale de votre comptabilité.",
          icon: "fileCheck"
        },
        {
          title: "Création d'Entreprise",
          description: "Conseil et accompagnement dans la création de personnalités morales : sociétés commerciales, industrielles, et Sociétés Civiles Immobilières (SCI). Choix de la structure juridique optimale et formalités de constitution.",
          icon: "building"
        },
        {
          title: "Assistance Opérationnelle",
          description: "Support administratif complet et gestion quotidienne pour libérer votre temps et vous concentrer sur votre cœur de métier. Facturation, suivi clients, relances, gestion des fournisseurs, coordination administrative.",
          icon: "settings"
        },
        {
          title: "Audit Interne & Contrôle",
          description: "Évaluation approfondie de vos processus internes, analyse des risques opérationnels et identification des opportunités d'amélioration. Mise en place de procédures de contrôle pour sécuriser votre activité.",
          icon: "search"
        },
        {
          title: "Accompagnement Stratégique",
          description: "Conseil en structuration d'entreprise, optimisation organisationnelle et accompagnement dans vos décisions stratégiques. Plan de développement, étude de faisabilité, business plan.",
          icon: "target"
        },
        {
          title: "Gestion Administrative RH",
          description: "Gestion des dossiers salariés, suivi des contrats, déclarations sociales, et conformité réglementaire. Libérez-vous des contraintes administratives liées aux ressources humaines.",
          icon: "users"
        },
        {
          title: "Suivi de Trésorerie",
          description: "Pilotage de trésorerie, prévisionnel financier, optimisation des flux de trésorerie et conseil en financement. Assurez la santé financière de votre entreprise.",
          icon: "trendingUp"
        }
      ],
      b2c: [
        {
          title: "Toutes Démarches Administratives",
          description: "Aide complète pour toutes vos procédures administratives françaises : CAF, Pôle Emploi, impôts, Sécurité Sociale, mairie, préfecture, et plus.",
          icon: "fileText",
          highlight: true
        },
        {
          title: "Déclarations Fiscales & Sociales",
          description: "Accompagnement spécialisé pour les ressortissants étrangers, notamment les citoyens américains. Déclarations d'impôts et déclarations sociales conformes aux réglementations françaises et internationales.",
          icon: "globe",
          highlight: true
        },
        {
          title: "Assistance Administrative à Domicile",
          description: "Gestion personnalisée de vos démarches administratives à votre domicile. Crédit d'impôt 50% applicable.",
          icon: "home",
          highlight: true
        },
        {
          title: "Gestion de Documents",
          description: "Organisation, classement et suivi de tous vos documents administratifs importants.",
          icon: "folderOpen"
        },
        {
          title: "Déclarations et Formulaires",
          description: "Aide à la complétion et au suivi de tous vos formulaires et déclarations administratives.",
          icon: "fileCheck"
        },
        {
          title: "Courriers Administratifs",
          description: "Rédaction et gestion de votre correspondance avec les administrations françaises.",
          icon: "mail"
        },
        {
          title: "Accompagnement Numérique",
          description: "Support pour vos démarches en ligne sur les portails administratifs français.",
          icon: "monitor"
        }
      ]
    },
    process: {
      title: "Notre Processus",
      subtitle: "Une approche structurée pour des résultats garantis",
      steps: [
        {
          number: "01",
          title: "Consultation Initiale",
          description: "Analyse de vos besoins et définition d'une stratégie personnalisée."
        },
        {
          number: "02",
          title: "Plan d'Action",
          description: "Élaboration d'un plan détaillé avec objectifs et échéances clairs."
        },
        {
          number: "03",
          title: "Mise en Œuvre",
          description: "Exécution rigoureuse avec suivi régulier et ajustements si nécessaire."
        },
        {
          number: "04",
          title: "Suivi & Optimisation",
          description: "Accompagnement continu pour maximiser les résultats à long terme."
        }
      ]
    },
    testimonials: {
      title: "Ce Que Disent Nos Clients",
      subtitle: "La confiance de nos clients est notre meilleure récompense",
      items: [
        {
          name: "Sophie Leroux",
          role: "Directrice, PME Brestoise",
          content: "Le Phare a transformé notre gestion financière. Son expertise et son professionnalisme sont exceptionnels.",
          rating: 5
        },
        {
          name: "Marc Dubois",
          role: "Entrepreneur",
          content: "Un service irréprochable ! Le Phare Administratif m'a fait gagner un temps précieux sur mes tâches administratives.",
          rating: 5
        },
        {
          name: "Claire Martin",
          role: "Particulier",
          content: "Enfin une solution efficace pour gérer mes démarches administratives. Je recommande vivement !",
          rating: 5
        }
      ]
    },
    faq: {
      title: "Questions Fréquentes",
      subtitle: "Trouvez rapidement les réponses à vos questions",
      items: [
        {
          question: "Quel est le montant du crédit d'impôt pour les particuliers ?",
          answer: "Les particuliers bénéficient d'un crédit d'impôt de 50% sur le montant des prestations d'assistance administrative à domicile. Par exemple, si vous payez 100€ de service, vous récupérez 50€ via votre crédit d'impôt l'année suivante."
        },
        {
          question: "Quels types de démarches administratives traitez-vous ?",
          answer: "Nous gérons toutes les procédures administratives françaises : CAF, Pôle Emploi, impôts, Sécurité Sociale, CPAM, retraite, permis de conduire, cartes grises, documents d'état civil, préfecture, mairie, courriers administratifs, formulaires en ligne, et bien plus."
        },
        {
          question: "Quels sont vos tarifs ?",
          answer: "Nos tarifs sont personnalisés selon vos besoins spécifiques. Pour les particuliers, n'oubliez pas que vous bénéficiez de 50% de crédit d'impôt ! Contactez-nous pour un devis gratuit et sans engagement."
        },
        {
          question: "Intervenez-vous uniquement à Brest ?",
          answer: "Nous sommes basés à Brest mais intervenons dans toute la région Bretagne. Des consultations à distance sont également possibles."
        },
        {
          question: "Quelle est votre disponibilité ?",
          answer: "Nous nous adaptons à vos contraintes. Les rendez-vous peuvent être pris du lundi au vendredi, avec possibilité d'interventions en soirée sur demande."
        },
        {
          question: "Êtes-vous certifié ?",
          answer: "Oui, nous sommes enregistrés sous le SIREN 102 363 074 avec le code APE 7022Z pour le conseil en gestion."
        },
        {
          question: "Proposez-vous un premier rendez-vous gratuit ?",
          answer: "Oui, la première consultation de 30 minutes est offerte pour évaluer vos besoins et vous présenter nos solutions."
        }
      ]
    },
    contact: {
      title: "Contactez-Nous",
      subtitle: "Commencez votre transformation dès aujourd'hui",
      form: {
        name: "Nom complet",
        email: "Adresse email",
        phone: "Téléphone",
        type: "Type de demande",
        typeProfessional: "Professionnel",
        typeIndividual: "Particulier",
        message: "Votre message",
        submit: "Envoyer",
        submitting: "Envoi en cours...",
        success: "Message envoyé avec succès ! Nous vous répondrons dans les plus brefs délais.",
        error: "Une erreur s'est produite. Veuillez réessayer."
      },
      info: {
        phone: "+33 6 50 75 74 52",
        email: "contact@lephareadministratif.fr",
        address: "9 RUE Pierre Loti, 29200 Brest, FRANCE"
      }
    },
    footer: {
      description: "Votre partenaire de confiance pour l'administration et la gestion d'entreprise.",
      legal: "SIREN : 102 363 074 | APE : 7022Z",
      rights: "© 2025 Le Phare Administratif et Gestion. Tous droits réservés.",
      links: {
        mentions: "Mentions Légales",
        privacy: "Politique de Confidentialité",
        terms: "Conditions Générales"
      }
    }
  },
  en: {
    nav: {
      services: "Services",
      process: "Process",
      testimonials: "Testimonials",
      faq: "FAQ",
      contact: "Contact"
    },
    hero: {
      tagline: "Your Strategic Guide in Administration and Management",
      subtitle: "Professional services for businesses and individuals - 50% tax credit for individuals",
      cta1: "Book a Consultation",
      cta2: "Contact Us"
    },
    taxCredit: {
      badge: "50% Tax Credit",
      title: "Benefit from 50% Tax Credit",
      subtitle: "Individual Services",
      description: "As an individual, enjoy a 50% tax credit on all our home administrative assistance services. A significant tax advantage to ease your administrative procedures.",
      example: "Example: €100 service = €50 after tax credit",
      cta: "Learn More"
    },
    serviceToggle: {
      professional: "I am a Professional",
      individual: "I am an Individual"
    },
    services: {
      title: "Our Services",
      subtitle: "Tailored solutions for your administrative and management needs",
      b2b: [
        {
          title: "Business Management Consulting",
          description: "In-depth financial supervision, internal auditing, and management control to optimize your performance. Financial statement analysis, management dashboard, profitability ratios, and strategic recommendations to maximize growth.",
          icon: "briefcase"
        },
        {
          title: "Electronic Invoicing",
          description: "Complete explanation and deployment of compliant electronic invoicing. Practical training on processing and managing e-invoices. Support in the digital transition of your accounting.",
          icon: "fileCheck"
        },
        {
          title: "Business Creation",
          description: "Advice and support in creating legal entities: commercial companies, industrial companies, and Civil Real Estate Companies (SCI). Optimal legal structure selection and incorporation formalities.",
          icon: "building"
        },
        {
          title: "Operational Assistance",
          description: "Complete administrative support and daily management to free up your time and focus on your core business. Invoicing, client follow-up, reminders, supplier management, administrative coordination.",
          icon: "settings"
        },
        {
          title: "Internal Audit & Control",
          description: "In-depth evaluation of your internal processes, operational risk analysis, and identification of improvement opportunities. Implementation of control procedures to secure your business.",
          icon: "search"
        },
        {
          title: "Strategic Support",
          description: "Business structuring advice, organizational optimization, and support in your strategic decisions. Development plan, feasibility study, business plan.",
          icon: "target"
        },
        {
          title: "HR Administrative Management",
          description: "Management of employee files, contract monitoring, social declarations, and regulatory compliance. Free yourself from HR administrative constraints.",
          icon: "users"
        },
        {
          title: "Cash Flow Management",
          description: "Cash flow management, financial forecasting, cash flow optimization, and financing advice. Ensure your company's financial health.",
          icon: "trendingUp"
        }
      ],
      b2c: [
        {
          title: "All Administrative Procedures",
          description: "Complete assistance for all your French administrative procedures: CAF, Employment Office, taxes, Social Security, city hall, prefecture, and more.",
          icon: "fileText",
          highlight: true
        },
        {
          title: "Tax & Social Declarations",
          description: "Specialized support for foreign nationals, especially US citizens. Tax returns and social declarations compliant with French and international regulations.",
          icon: "globe",
          highlight: true
        },
        {
          title: "Home Administrative Assistance",
          description: "Personalized management of your administrative tasks at your home. 50% tax credit applicable.",
          icon: "home",
          highlight: true
        },
        {
          title: "Document Management",
          description: "Organization, filing and tracking of all your important administrative documents.",
          icon: "folderOpen"
        },
        {
          title: "Declarations & Forms",
          description: "Help with completing and tracking all your administrative forms and declarations.",
          icon: "fileCheck"
        },
        {
          title: "Administrative Correspondence",
          description: "Writing and managing your correspondence with French administrations.",
          icon: "mail"
        },
        {
          title: "Digital Support",
          description: "Support for your online procedures on French administrative portals.",
          icon: "monitor"
        }
      ]
    },
    process: {
      title: "Our Process",
      subtitle: "A structured approach for guaranteed results",
      steps: [
        {
          number: "01",
          title: "Initial Consultation",
          description: "Analysis of your needs and definition of a personalized strategy."
        },
        {
          number: "02",
          title: "Action Plan",
          description: "Development of a detailed plan with clear objectives and timelines."
        },
        {
          number: "03",
          title: "Implementation",
          description: "Rigorous execution with regular monitoring and adjustments as needed."
        },
        {
          number: "04",
          title: "Follow-up & Optimization",
          description: "Ongoing support to maximize long-term results."
        }
      ]
    },
    testimonials: {
      title: "What Our Clients Say",
      subtitle: "Our clients' trust is our best reward",
      items: [
        {
          name: "Sophie Leroux",
          role: "Director, Brest SME",
          content: "Le Phare transformed our financial management. Their expertise and professionalism are exceptional.",
          rating: 5
        },
        {
          name: "Marc Dubois",
          role: "Entrepreneur",
          content: "Impeccable service! Le Phare Administratif saved me precious time on administrative tasks.",
          rating: 5
        },
        {
          name: "Claire Martin",
          role: "Individual",
          content: "Finally an effective solution to manage my administrative procedures. Highly recommended!",
          rating: 5
        }
      ]
    },
    faq: {
      title: "Frequently Asked Questions",
      subtitle: "Find answers to your questions quickly",
      items: [
        {
          question: "What is the tax credit amount for individuals?",
          answer: "Individuals benefit from a 50% tax credit on home administrative assistance services. For example, if you pay €100 for service, you recover €50 through your tax credit the following year."
        },
        {
          question: "What types of administrative procedures do you handle?",
          answer: "We manage all French administrative procedures: CAF, Employment Office, taxes, Social Security, CPAM, retirement, driver's license, vehicle registration, civil status documents, prefecture, city hall, administrative letters, online forms, and much more."
        },
        {
          question: "What are your rates?",
          answer: "Our rates are customized according to your specific needs. For individuals, don't forget you benefit from a 50% tax credit! Contact us for a free, no-obligation quote."
        },
        {
          question: "Do you only work in Brest?",
          answer: "We are based in Brest but operate throughout the Brittany region. Remote consultations are also available."
        },
        {
          question: "What is your availability?",
          answer: "We adapt to your constraints. Appointments can be made Monday to Friday, with evening interventions available upon request."
        },
        {
          question: "Are you certified?",
          answer: "Yes, we are registered under SIREN 102 363 074 with APE code 7022Z for management consulting."
        },
        {
          question: "Do you offer a free first appointment?",
          answer: "Yes, the first 30-minute consultation is free to assess your needs and present our solutions."
        }
      ]
    },
    contact: {
      title: "Contact Us",
      subtitle: "Start your transformation today",
      form: {
        name: "Full name",
        email: "Email address",
        phone: "Phone",
        type: "Request type",
        typeProfessional: "Professional",
        typeIndividual: "Individual",
        message: "Your message",
        submit: "Send",
        submitting: "Sending...",
        success: "Message sent successfully! We will respond to you as soon as possible.",
        error: "An error occurred. Please try again."
      },
      info: {
        phone: "+33 6 50 75 74 52",
        email: "contact@lephareadministratif.fr",
        address: "9 RUE Pierre Loti, 29200 Brest, FRANCE"
      }
    },
    footer: {
      description: "Your trusted partner for business administration and management.",
      legal: "SIREN: 102 363 074 | APE: 7022Z",
      rights: "© 2025 Le Phare Administratif et Gestion. All rights reserved.",
      links: {
        mentions: "Legal Notice",
        privacy: "Privacy Policy",
        terms: "Terms & Conditions"
      }
    }
  }
};
